import { siteConfig } from '@/config/site.config'

export const contentI18nFr = (
  <div>
    <h2>Définitions</h2>
    <ul>
      <li>« <b>Société</b> », « Nous », « JBDA » ou le « Vendeur » : désigne la personne morale mettant à disposition le Service.</li>
      <li>« <b>Site</b> » ou, « Site web » : désigne le présent site via lequel le Souscripteur prend attache avec la Société.</li>
      <li>« <b>Plateforme</b> » : désigne la plateforme mise à disposition par la Société afin que le Souscripteur puisse jouir du Service qui y est proposé.</li>
      <li>« <b>Conditions Générales de Vente</b> », « CGV » ou les « Conditions » : désigne le document constitué par JBDA qui a pour finalité de faire part au Souscripteur des informations légales et obligatoires relatives au Service fourni par la Société. </li>
      <li>« <b>Client</b> », « <b>Souscripteur</b> » ou « Vous » : désigne toute personne ayant procédé à l’utilisation de la Plateforme  et/ou procédé à une Souscription. Cette dénomination comprend tant la clientèle professionnelle que la clientèle particulière. Dès lors qu’il n’y a pas lieu de distinguer ces deux types de clientèles, les dénominations ci-dessus feront foi. </li>
      <li>« <b>Parties</b> » : désigne la dénomination collective qui comprend respectivement la Société ainsi que le Souscripteur. </li>
      <li>« <b>Service</b> » : désigne le Service proposé à la vente par la Société à travers le Site web. Plus précisément JBDA propose un service de séquestre d’actifs numériques. </li>
      <li>« <b>Souscription</b> » : désigne la procédure permettant au Client de commander le Service fourni par la Société et qui implique le paiement du Prix par celui-ci. </li>
      <li>« <b>Conditions Particulières de Vente</b> », « CPV » : désigne le contrat de prestation de service conclu entre JBDA et le Client qui a vocation à encadrer la fourniture du Service de manière personnalisé. À ce titre, il est à noter que les Conditions Particulières de Vente prévalent sur les Conditions Générales de Vente. </li>
      <li>« <b>Utilisateur</b> » : désigne toute personne consultant le Site. </li>
    </ul>
    <h2> Traitement des données et sécurité informatique </h2>
    <p>
      La finalité des présentes dispositions est d&apos;informer l&apos;Utilisateur et le Souscripteur sur les raisons pour lesquelles JBDA collecte, traite et protège leurs données personnelles. La présente politique rédigée par la Société affirme et garantit que le consommateur au sens du Code de la consommation est conscient des éléments suivants :
    </p>
    <ul>
      <li>Sur la manière dont leurs données personnelles sont collectées et sécurisées</li>
      <li>Sur le type de données recueillies</li>
      <li>Sur l&apos;utilisation des données recueillies</li>
      <li>Sur la finalité de cette collecte</li>
      <li>Sur les droits dont ils disposent concernant ces données</li>
      <li>Sur la politique du Site en matière de cookies</li>
    </ul>
    <p>
      Cette politique complète les <a href="./legal-mentions">mentions légales</a> et les <a href="./cgu">conditions générales de vente du Service</a> de notre Site.
    </p>
    <h2>Lois applicables</h2>
    <p>
      Conformément au Réglement général sur la protection des données (RGPD), cette politique de confidentialité est conforme aux règlements suivants.
    </p>
    <p>
      Les données à caractère personnel doivent être :
    </p>
    <ul>
      <li>
        Traitées de manière licite, loyale et transparente au regard de la personne concernée (licéité, loyauté, transparence)
      </li>
      <li>
        Collectées pour des finalités déterminées, explicites et légitimes, et ne pas être traitées ultérieurement d&apos;une manière incompatible avec ces finalités le traitement ultérieur à des fins archivistiques dans l&apos;intérêt public, à des fins de recherche scientifique ou historique ou à des fins statistiques n&apos;est pas considéré, conformément à l&apos;article 89, paragraphe 1. comme incompatible avec les finalités initiales (limitation des finalités)
      </li>
      <li>
        Adéquates, pertinentes et limitées à ce qui est nécessaire au regard des finalités pour lesquelles elles sont traitées (minimisation des données)
      </li>
      <li>
        Exactes et, si nécessaire, tenues à jour : toutes les mesures raisonnables doivent être prises pour que les données à caractère personnel qui sont inexactes, eu égard aux finalités pour lesquelles elles sont traitées, soient effacées ou rectifiées sans tarder (exactitude)
      </li>
      <li>
        Conservées sous une forme permettant l&apos;identification des personnes concemées pendant une durée n&apos;excédant pas celle nécessaire au regard des finalités pour lesquelles elles sont traitées : les données à caractère personnel peuvent être conservées pour des durées plus longues dans la mesure où elles seront traitées exclusivement à des fins archivistiques dans l&apos;intérêt public, à des fins de recherche scientifique ou historique ou à des fins statistiques conformément à l&apos;article 89, paragraphe 1. pour autant que soient mises en œuvre les mesures techniques et organisationnelles appropriées requises par le règlement afin de garantir les droits et libertés de la personne concemée (limitation de la conservation)
      </li>
      <li>
        Traitées de façon à garantir une sécurité appropriée des données à caractère personnel, ÿ compris la protection contre le traitement non autorisé ou illicite et contre la perte, la destruction ou les dégâts d&apos;origine accidentelle, à l&apos;aide de mesures techniques ou organisationnelles appropriées (intégrité et confidentialité).
      </li>
    </ul>
    <p>
      Le traitement n&apos;est licite que si, et dans la mesure où, au moins une des conditions suivantes est remplie :
    </p>
    <ul>
      <li>
        La personne concernée a consenti au traitement de ses données à caractère personnel pour une ou plusieurs finalités spécifiques.
      </li>
      <li>
        Le traitement est nécessaire à l&apos;exécution d&apos;un contrat auquel la personne concemée est partie ou à l&apos;exécution de mesures précontractuelles prises à la demande de celle-ci.
      </li>
      <li>
        Le traitement est nécessaire au respect d&apos;une obligation légale à laquelle le responsable du traitement est soumis.
      </li>
      <li>
        Le traitement est nécessaire à la sauvegarde des intérêts vitaux de la personne concernée ou d&apos;une autre personne physique.
      </li>
      <li>
        Le traitement est nécessaire à l&apos;exécution d&apos;une mission d&apos;intérêt public ou relevant de l&apos;exercice de l&apos;autorité publique dont est investi le responsable du traitement.
      </li>
      <li>
        Le traitement est nécessaire aux fins des intérêts légitimes poursuivis par le responsable du traitement ou par un tiers, à moins que ne prévalent les intérêts ou les libertés et droits fondamentaux de la personne concernée qui exigent une protection des données à caractère personnel, notamment lorsque la personne concemée est un enfant.
      </li>
    </ul>
    <h2>Consentement</h2>
    <p>
      Les utilisateurs conviennent qu&apos;en utilisant notre Site, ils consentent :
    </p>
    <ul>
      <li>Aux conditions énoncées dans la présente politique de confidentialité</li>
      <li>A la collecte, l&apos;utilisation et la conservation des données énumérées dans la présente politique</li>
    </ul>
    <h2>Collecte et sécurisation des données personnelles </h2>
    <p>
      La Société met en place des mesures de sécurité organisationnelles et techniques adaptées afin de protéger vos Données à caractère personnel contre toute intrusion malveillante, perte, altération ou divulgation à des tiers non autorisés, et plus généralement pour préserver la sécurité et la confidentialité desdites données à caractère personnel et garantir un niveau de sécurité adapté au risque. En raison des difficultés inhérentes à l’exercice d’une activité sur internet et des risques, que Vous connaissez, résultant d’une transmission de données par voie électronique, la Société ne saurait toutefois être tenue à une obligation de résultat. Conformément avec le Règlement EU 2016/679 relative à la protection des données personnelles (RGPD), JBDA assure à l’Utilisateur et au Souscripteur que les données personnelles recueillies sont traitées en conformité avec le RGPD.
    </p>
    <p>
      JBDA collecte et utilise uniquement les données personnelles nécessaires (i) à la bonne réalisation du processus de Souscription et (ii) à la correcte exécution du Service.
    </p>
    <h3>Le type de données pesonnelles collectées</h3>
    <p>
      Nous pouvons être amenés à mettre en œuvre des traitements de vos données à caractère personnel qui sont les suivantes :
    </p>
    <ul>
      <li>Nom</li>
      <li>Prénoms</li>
      <li>E-mail</li>
      <li>Adresse postale</li>
      <li>Nationalité</li>
      <li>Profession</li>
      <li>Sources de revenus</li>
    </ul>
    <p>
      Il est à noter que la liste mentionnée ci-dessus est une énumération  non-exhaustive et qu&apos;elle pourra faire l’objet de mises à jour successives notamment pour des raisons industrielles, commerciales ou réglementaire.
    </p>
    <p>
      Ces données peuvent être recueillies lors des actions suivantes :
    </p>
    <ul>
      <li>Souscription au Service</li>
      <li>Inscription à notre newsletter</li>
      <li>Prise de rendez-vous ou demande de contact</li>
    </ul>
    <p>
      Veuillez noter que nous ne collectons que les données qui nous aident à atteindre l&apos;objectif énoncé dans cette politique de confidentialité. Nous ne recueillerons pas de données supplémentaires sans vous en informer au préalable.
    </p>
    <h2>Chatbot IA (Assistant conversationnel)</h2>
    <p>
      Nous mettons à votre disposition un assistant conversationnel (« Chatbot ») reposant sur la technologie ChatGPT d’OpenAI, L.L.C., 3180 18th Street, San Francisco (États‑Unis). Lorsque vous échangez avec ce Chatbot, les messages que vous saisissez peuvent contenir des données à caractère personnel.
    </p>
    <h3>Données traitées</h3>
    <ul>
      <li>Contenu des messages que vous envoyez au Chatbot</li>
      <li>Métadonnées techniques (horodatage, identifiant de session, adresse IP tronquée)</li>
    </ul>
    <h3>Finalités et base légale</h3>
    <p>
      Ces traitements sont nécessaires à notre intérêt légitime (article 6‑1‑f RGPD) consistant à répondre aux questions des visiteurs et à améliorer notre support. Aucune décision automatisée produisant des effets juridiques n’est prise sur la base des réponses du Chatbot.
    </p>
    <h3>Destinataires et transferts hors UE</h3>
    <p>
      Les données sont traitées par OpenAI aux États‑Unis. Le transfert est encadré par les Clauses Contractuelles Types de la Commission européenne et l’adhésion d’OpenAI au Data Privacy Framework UE‑USA.
    </p>
    <h3>Durée de conservation</h3>
    <p>
      JBDA ne conserve aucun log des conversations. OpenAI conserve les entrées et sorties pendant un maximum de 30 jours, exclusivement aux fins de détection des abus, puis les supprime automatiquement.
    </p>
    <h3>Transparence – AI Act</h3>
    <p>
      Les réponses du Chatbot sont générées automatiquement par une intelligence artificielle ; veuillez les vérifier avant toute décision. Nous vous invitons à ne pas fournir d’informations sensibles (données relatives à la santé, numéros de carte bancaire, etc.).
    </p>
    <h2>La finalité de cette collecte</h2>
    <p>
      Lors de vos échanges avec la Société, cette dernière peut être amenée à collecter et à traiter des Données à caractère personnel Vous concernant, pour la gestion des activités. Dans ce cadre, la Société applique les principes définis par les dispositions légales et réglementaires en    matière de protection des Données à caractère personnel, en particulier dans le Règlement (UE) 2016/679 du 27 avril 2016 relatif à la protection des personnes physiques à l’égard du Traitement des Données à caractère personnel (« RGPD ») ou encore la loi 78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés (dite « loi informatique et libertés ») et ses décrets d’application. En outre, le recueil et le traitement des données suivantes ont pour unique finalité la réalisation effective du Service.
    </p>
    <p>
      Par ailleurs, JBDA garantit fournir ses meilleurs efforts en matière de sécurité de vos informations personnelles. En revanche, elle ne peut garantir  que des tiers non autorisés puisse s’introduire dans notre système de sécurité et utiliser vos informations personnelles à des fins non-conforme à la finalité du traitement. Vous acceptez donc fournir vos informations personnelles en pleine conscience.
    </p>
    <p>
      Les finalités secondaires de la collecte des données étant la :
    </p>
    <ul>
      <li>Communication aux partenaires des données indispensables à la réalisation du Service, qui sera effectuée en conformité avec les dispositions du présent article</li>
      <li>Gestion, traitement, suivi des demandes d’information et échanges avec les Souscripteurs</li>
      <li>Gestion de nos relations avec nos Clients (relations précontractuelles, contractuelles et post-contractuelles)</li>
      <li>Gestion de nos relations avec nos partenaires et prestataires</li>
      <li>Gestion par la Société des demandes d’exercice des droits des personnes concernées en matière de protection des Données à caractère personnel, conformément à ses obligations légales et réglementaires</li>
    </ul>
    <p>
      Par ailleurs, la collecte de donnée est limitée dans le temps à une durée de deux (2) ans à compter de la collecte des données.
    </p>
    <h2>Partage des données personnelles</h2>
    <h3>Employés</h3>
    <p>
      Nous pouvons divulguer à tout membre de notre organisation les données dont il a raisonnablement besoin pour réaliser les objectifs énoncés dans la présente politique.
    </p>
    <h3>Partenaire PSAN</h3>
    <p>
      Nous pouvons communiquer les données collectées à notre partneaire PSAN pour la bonne réalisation du Service.
    </p>
    <h3>Autres divulgations</h3>
    <p>
      Nous nous engageons à ne pas vendre ou partager vos données avec d&apos;autres tiers, sauf dans les cas suivants :
    </p>
    <ul>
      <li>Si la loi l&apos;exige</li>
      <li>Si elle est requise pour toute procédure judiciaire</li>
      <li>Pour prouver ou protéger nos droits légaux</li>
      <li>A des acheteurs ou des acheteurs potentiels de cette société dans le cas où nous cherchons à la vendre la société</li>
    </ul>
    <p>
      Si vous suivez des hyperliens de notre Site vers un autre Site, veuillez noter que nous ne sommes pas responsables et n&apos;avons pas de contrôle sur leurs politiques et pratiques de confidentialité.
    </p>
    <h2>Vos droits en tant qu&apos;utilisateur</h2>
    <p>
      En vertu du RGPD, les utilisateurs ont les droits suivants en tant que personnes concernées :
    </p>
    <ul>
      <li>Droit d&apos;accès</li>
      <li>Droit de rectification</li>
      <li>Droit à l&apos;effacement</li>
      <li>Droit de restreindre le traitement</li>
      <li>Droit à la portabilité des données</li>
      <li>Droit d&apos;objection</li>
    </ul>
    <p>
      Vous trouverez de plus amples informations sur ces droits au chapitre 3 (art 12-23) du RGPD.
    </p>
    <h2>Comment modifier, supprimer ou contester les données recueillies</h2>
    <p>
      Si vous souhaitez que vos renseignements soient supprimés ou modifiés d&apos;une façon ou d&apos;une autre, vous pouvez contacter notre service de protection de la vie privée par email : <a href={`mailto:${siteConfig.mail.privacyAddress}`}>{siteConfig.mail.privacyAddress}</a>.
    </p>
    <h2>Politique sur les cookies</h2>
    <p>
      Notre Site web utilise des cookies et des technologies similaires pour améliorer votre expérience utilisateur, fournir certaines fonctionalités et analyser le trafic. L&apos;analyse de trafic ne démarre qu&apos;avec votre accord et s&apos;arrête sur demande. Ces outils nous aident à comprendre comment les visiteurs interagissent avec notre Site web, nous permettant ainsi d&apos;améliorer nos services.
    </p>
    <p>
      Si vous choisissez de ne pas donner votre consentement, ou si vous retirez votre consentement à un moment donné, votre expérience utilisateur sur notre Site ne sera pas diminuée, mais nous ne serons pas en mesure de capter finement vos préférences et l&apos;efficacité de notre Site et certaines fonctionalités ne seront pas accessibles (prise de rendez-vous, inscription à la Newsletter).
    </p>
    <p>
      Vous avez la possibilité de gérer vos préférences en matière de cookies à tout moment via les paramètres de votre navigateur et le lien vers les cookies présent sur chaque bas de page.
    </p>
    <h2>Modifications</h2>
    <p>
      Cette politique de confidentialité peut être modifiée à l&apos;occasion afin de maintenir la conformité avec la loi et de tenir compte de tout changement à notre processus de collecte de données. Nous recommandons à nos utilisateurs de vérifier notre politique de temps à autre pour s&apos;assurer qu&apos;ils soient informés de toute mise à jour. Au besoin, nous pouvons informer les utilisateurs par courriel des changements apportés à cette politique.
    </p>
    <h2>Contact</h2>
    <p>
      Si vous avez des questions à nous poser, n&apos;hésitez pas à communiquer avec nous en utilisant ce qui suit :
    </p>
    <ul>
      <li>Numéro de téléphone : {siteConfig.phone}</li>
      <li>Adresse e-mail : <a href={`mailto:${siteConfig.mail.contactAddress}`}>{siteConfig.mail.contactAddress}</a></li>
      <li>Adresse : JBDA - Bat. 3, 535 Route des Lucioles, 06560 Sophia Antipolis</li>
    </ul>
  </div>
)
